import { Inject, Injectable } from '@angular/core';
import { CommunityServiceBase } from '@common/services/community.service.base';
import { HttpClient } from '@angular/common/http';
import { API_URL, DEFAULT_COMMUNITY } from '@common/app/app.config';
import { RouteService } from '@common/infrastructure/params-service';
import { CommunityMode, EnjpCommunity } from '../model/community';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class EnjpCommunityService extends CommunityServiceBase<EnjpCommunity> {
    constructor(
        protected http: HttpClient,
        @Inject(API_URL) protected baseUrl: string,
        @Inject(DEFAULT_COMMUNITY) protected defaultCommunity: string,
        protected routeService: RouteService,
    ) {
        super(http, baseUrl, defaultCommunity, routeService);
    }

    protected getCommunityInstance(): EnjpCommunity {
        return new EnjpCommunity();
    }

    get isCommunityRegistrationEnabled$(): Observable<boolean> {
        return this.community$.pipe(
            map((community) =>
                [CommunityMode.Default, CommunityMode.Hidden].includes(
                    community.communityMode,
                ),
            ),
        );
    }
}
